import { Product } from '@@types'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { ProductCard } from '@widgets/product-preview'

import { useAnalytics } from '@shared/lib/analytics'
import ArrowLink from '@shared/ui/arrow-link'
import CardSkeleton from '@shared/ui/card-skeleton'

import styles from './styles.module.scss'


interface ProductCarouselProps {
  title?: string;
  products: Product[];
  link?: string;
  loading?: boolean;
  swiperClassName?: string;
  onLinkClick?: () => void;
  /** Название списка для аналитики */
  listName?: string;
  /** ID списка для аналитики */
  listId?: string;
}

function ProductsLoading () {
  return (
    <div className={styles.skeleton}>
      {Array.from({ length: 8 }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  )
}

export function ProductCarousel (props: ProductCarouselProps) {
  const { title, products, link, loading, swiperClassName, onLinkClick, listName, listId } = props
  const { t: tc } = useTranslation('common')
  const { viewItemList } = useAnalytics()

  // Определяем название списка для аналитики
  const analyticsListName = listName || title || 'Product Carousel'
  const analyticsListId = listId || 'product_carousel'

  // Track view_item_list when products are displayed
  useEffect(() => {
    if (products?.length && !loading) {
      viewItemList(products, analyticsListName, analyticsListId)
    }
  }, [ products, loading, viewItemList, analyticsListName, analyticsListId ])

  if (loading) {
    return <ProductsLoading />
  }

  if (!products?.length) {
    return null
  }

  return (
    <section className={styles.root}>
      {(title || link) && (
        <div className={styles.root__top}>
          {title && <h2 className={styles.root__title}>{title}</h2>}
          {link && <ArrowLink to={link} text={tc('more')} onClick={onLinkClick} />}
        </div>
      )}

      <Swiper
        spaceBetween={8}
        slidesPerGroup={2}
        slidesPerView="auto"
        modules={[ Navigation ]}
        navigation={true}
        className={swiperClassName}
      >
        {products.map((p) => {
          return (
            <SwiperSlide className={styles.slide} key={p.id}>
              <ProductCard data={p} listName={analyticsListName} listId={analyticsListId} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}
